import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { TESTIMONIALS, IMAGES } from "../../lib/medskin-data";

export const Testimonials = () => {
  return (
    <section id="testimonials" className="py-24 md:py-36 bg-[#F7F6F3]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl mb-16"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#C4A981]"></span>
            <span className="text-[11px] uppercase tracking-[0.3em] text-[#635D56]">Kundeuttalelser</span>
          </div>
          <h2 className="font-serif text-3xl md:text-5xl leading-[1.08] text-[#2C2C2A] tracking-tight font-light" data-testid="testimonials-headline">
            Stemmer fra <em className="italic text-[#4A4238]">vår klinikk</em>.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="bg-white p-8 md:p-10 rounded-3xl border border-[#E5E0DA] hover:shadow-[0_20px_50px_-25px_rgba(74,66,56,0.25)] transition-all duration-500 flex flex-col"
              data-testid={`testimonial-card-${i}`}
            >
              <div className="flex items-center gap-1 text-[#C4A981] mb-6">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star key={idx} size={14} fill="#C4A981" strokeWidth={0} />
                ))}
              </div>
              <blockquote className="font-serif text-xl md:text-2xl text-[#2C2C2A] leading-[1.35] font-light flex-1">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-4 pt-6 border-t border-[#E5E0DA]">
                <img
                  src={IMAGES.testimonialAvatars[i]}
                  alt={t.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <div className="text-sm text-[#2C2C2A]">{t.name}</div>
                  <div className="text-[10px] uppercase tracking-[0.22em] text-[#635D56] mt-1">{t.location}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
